import React, { Component } from "react";
import { LoadingSpinner } from "styled_components/Common/LoadingSpinner";
import Radio from "./../Common/Radio";

export default class MFAOption extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: "EMAIL",
      error: false,
      success: false,
      showOptions: false,
      enabled: true,
      requestMFAButtonText: "SEND MY CODE",
      hideOptions: false,
      sharedUserName: "",
      sharedUserEmail: "",
    };
  }

  changeMFAType = (value) => {
    const { disabledMfaTimeout } = this.props;
    const { requestMFAButtonText } = this.state;
    disabledMfaTimeout();
    this.setState({ selected: value });
    if (requestMFAButtonText === "SUBMIT CODE") {
      this.setState({
        requestMFAButtonText: "RESEND CODE",
        enabled: true,
        hideOptions: false,
      });
    }
  };

  handleSharedUserInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  submitMfaOption = async () => {
    const { selected, enabled, sharedUserName, sharedUserEmail } = this.state;
    const {
      selectedCallback,
      auth_status: {
        user,
        attemptCount,
        credentials: { username },
        user: { sharedUser },
      },
    } = this.props;
    selectedCallback(selected);

    if (enabled) {
      this.setState({
        requestMFAButtonText: "SUBMIT CODE",
        enabled: false,
        hideOptions: true,
      });
    } else {
      this.setState({
        requestMFAButtonText: sharedUser ? "SUBMIT CODE" : "RESEND CODE",
        enabled: true,
        hideOptions: false,
      });
    }
    if (user?.sharedUser) {
      const sharedUserData = { name: sharedUserName, email: sharedUserEmail };
      sessionStorage.setItem("sharedUser", JSON.stringify(sharedUserData));
    }
    this.makeMfaRequest(username, attemptCount, selected);
  };

  makeMfaRequest = async (username, attemptCount, selected) => {
    const { mfaOptionRequest, disabledMfaTimeout } = this.props;
    disabledMfaTimeout();

    try {
      const response = await mfaOptionRequest(username, attemptCount, selected);
      if (response.status === 200 && !response.data.error) {
        this.setState({ success: true });
      } else {
        this.setState({ error: true });
      }
    } catch (e) {
      this.setState({ error: true, errorMessage: e });
    }
  };

  submitCode = () => {
    const { inputEnterCallback } = this.props;
    const input = "";
    inputEnterCallback(input);

    this.setState({ requestMFAButtonText: "RESEND CODE", enabled: true });
  };

  getRadioButtonOptions = (email, phone) => {
    if (!email && !phone) {
      return [];
    }

    const options = [];
    if (email) {
      options.push({ value: "EMAIL", name: "Send to email", details: email });
    }

    if (phone) {
      options.push({ value: "SMS", name: "Send to phone", details: phone });
    }

    return options;
  };

  getDomain = (email) => {
    const parts = email.split("@");
    return parts.length > 1 ? parts[1].toLowerCase() : "";
  };

  checkButtonEnabled = () => {
    const {
      enabled: newEnabled,
      auth_status: { user },
      userEmail,
      setError,
    } = this.props;
    const { enabled, sharedUserName, sharedUserEmail } = this.state;

    if (user?.sharedUser) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      // Name regex pattern (allows letters, spaces, and hyphens, minimum 2 characters)
      const nameRegex = /^[a-zA-Z\s-]{2,}$/;

      const isNameValid = nameRegex.test(sharedUserName);
      const isEmailValid = emailRegex.test(sharedUserEmail);
      // Check if shared user email is different from authenticated user email
      const isEmailDifferent =
        sharedUserEmail.toLowerCase() !== userEmail.toLowerCase();

      const userDomain = this.getDomain(userEmail);
      const sharedUserDomain = this.getDomain(sharedUserEmail);

      const isSameDomain =
        userDomain && sharedUserDomain && userDomain === sharedUserDomain;
      const isValid =
        isNameValid && isEmailValid && isEmailDifferent && isSameDomain;

      if (!isValid && sharedUserEmail !== "") {
        setError("Email cannot be used.");
      } else {
        setError(null);
      }
      return isValid;
    } else {
      return newEnabled || enabled;
    }
  };

  resetToLogin = () => {
    const { resetLogin } = this.props;
    this.setState({
      sharedUserName: "",
      sharedUserEmail: "",
    });
    resetLogin();
  };

  componentDidUpdate(prevProps) {
    const {
      forceShow,
      requestType: incomingRequestType,
      auth_status: { user: { authTypes } = {} } = {},
    } = this.props;
    const { auth_status: { user: { authTypes: prevAuthTypes } = {} } = {} } =
      prevProps;
    const { enabled, showOptions } = this.state;

    if (forceShow && !showOptions) {
      this.setState({
        showOptions: true,
        requestMFAButtonText: "RESEND CODE",
        enabled: true,
        hideOptions: false,
      });
    }

    if (incomingRequestType === "RESEND CODE" && !enabled) {
      this.setState((state) => ({
        ...state,
        requestMFAButtonText: "RESEND CODE",
        enabled: true,
        hideOptions: false,
      }));
    }

    if (authTypes !== prevAuthTypes) {
      this.setState({ showOptions: true });
    }
  }

  render() {
    const {
      showOptions,
      sharedUserName,
      sharedUserEmail,
      requestMFAButtonText,
      selected,
      hideOptions,
    } = this.state;
    const {
      email,
      phone,
      resetMfaOptions,
      code,
      setMFACode,
      auth_status: { user, message },
    } = this.props;
    const options = this.getRadioButtonOptions(email, phone);
    const isSharedUser = user?.sharedUser;

    return (
      <div
        className={`mfa-option ${!showOptions ? "hide" : ""} ${
          hideOptions ? "hide-options" : ""
        }`}
      >
        {showOptions && (
          <>
            {message.includes("Validating") && (
              <div className="mfa-validation">
                <div className="body10">Validating...</div>
                <LoadingSpinner />
              </div>
            )}
            {hideOptions && (
              <div
                className="reset-mfa-options body10"
                onClick={() => {
                  resetMfaOptions();
                }}
              >
                Reset your choice ?
              </div>
            )}

            {!message.includes("Validating") && hideOptions && (
              <div className="mfa-code">
                <div className="label body10">MFA Code</div>
                <input
                  value={code}
                  className="body10"
                  type="password"
                  placeholder="******"
                  onChange={setMFACode}
                />
              </div>
            )}
            {!isSharedUser && (
              <div className={"mfa-option-wrapper"}>
                <Radio
                  callback={this.changeMFAType}
                  name="accessibility"
                  value={selected}
                  hidden={false}
                  toggle={true}
                  options={options}
                />
              </div>
            )}
            {isSharedUser && (
              <div className="shared-user-form">
                <div className="input-wrapper">
                  <div className="label body10">Name</div>
                  <input
                    type="text"
                    name="sharedUserName"
                    value={sharedUserName}
                    onChange={this.handleSharedUserInput}
                    className="body10"
                    placeholder="Enter your name"
                  />
                </div>
                <div className="input-wrapper">
                  <div className="label body10">Email</div>
                  <input
                    type="email"
                    name="sharedUserEmail"
                    value={sharedUserEmail}
                    onChange={this.handleSharedUserInput}
                    className="body10"
                    placeholder="Enter your email"
                  />
                </div>
              </div>
            )}

            <button
              className="labels21"
              id="request-mfa"
              module="support"
              disabled={!this.checkButtonEnabled()}
              onClick={
                requestMFAButtonText === "SUBMIT CODE"
                  ? this.submitCode
                  : this.submitMfaOption
              }
              cypressId="request-mfa"
            >
              {requestMFAButtonText}
            </button>

            <div
              className={`reset-link ${
                isSharedUser ? "shared-user" : ""
              } body10`}
              onClick={this.resetToLogin}
            >
              Login as Account
            </div>
          </>
        )}
      </div>
    );
  }
}
